<template>
  <v-layout style="width:100vw;height:100vh" class="pa-0 ma-0">
    <component style="width:100%;height:100vh" :is="component">
        <slot/>
    </component>
    <v-snackbar
      v-model="snackbar.visible"
      :color="snackbar.color"
      multi-line
      :timeout="6000"
      
    >
      {{ snackbar.text }}
      <v-btn
        dark
        flat
        @click="snackbar.visible = false"
      >
        Ok
      </v-btn>
    </v-snackbar>
 </v-layout>
</template>

<script>
    const Bus = require('@/plugins/EventBus').EventBus
    export default {
        name: 'App',
        components: {
            negocio: () => import('./pages/negocio'),
            login: () => import('./pages/login'),
            negocios: () => import('./pages/negocios')
        },
        data() {
            return {
                snackbar: {
                    visible: null,
                    color: 'info',
                    text: ''
                },
                component: null
            }
        },
        mounted() {
            Bus.$on('ALERT', payload => {
                Object.keys(payload).forEach(k => {
                    this.snackbar[k] = payload[k]
                })
                this.snackbar.visible = true
            })
            if (!this.$auth.currentUser) {
                this.component = 'login'
            } else {
                this.component = 'negocio'
            }
            this.$auth.onAuthStateChanged(auth => {
                if (!auth) {
                    this.$router.push('/login')
                } else {
                    if (this.$route.params.negocio) {
                        this.component = 'negocio'
                    } else {
                        this.$System.currentUser.ref.child('Negocio').on('value', snap => {
                            if (!snap.exists()) {
                                
                                this.$router.push(`/${this.$t('links.misnegocios')}`)
                            }
                        })
                    }
                }
            })
        }
    }
</script>
<style>
html, body {
    height: 100%;
    overflow: hidden;
}
#App {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    overflow: auto;
}
</style>